module.exports = __webpack_public_path__ + "img/versace_xrpl2 00.18.18.c01357f.png";